import React from "react";
import TodoList from "./component/TodoList";
import { Box, Typography } from "@mui/material";

const App = () => {
  return (
    <Box sx={{ margin: "30px" }}>
      <Typography variant="h4" align="center" margin={4}>
        Kanban Board
      </Typography>
      <TodoList />
    </Box>
  );
};

export default App;
